import { Spin, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

import EmptyState from "../EmptyState";
import styles from "./styles.module.css";

/**
 * Shared panel for every report widget, so charts, lists and tables all sit in
 * the same card chrome instead of each partial hand-rolling its own header.
 */
const ChartCard = ({
  icon,
  tone = "blue",
  title,
  hint,
  action,
  loading = false,
  isEmpty = false,
  emptyTitle = "داده‌ای برای نمایش نیست",
  emptyText = "بازه‌ی زمانی را بازتر کن یا فیلترها را تغییر بده.",
  flush = false,
  children,
}) => (
  <div className={styles.card}>
    <div className={styles.header}>
      <div className="section-heading">
        {icon && (
          <div className={`section-heading-icon kpi-icon-${tone}`}>{icon}</div>
        )}
        <h6 className="section-heading-text">{title}</h6>
        {hint && (
          <Tooltip title={hint} trigger={["hover", "click"]}>
            <InfoCircleOutlined className={styles.hint} />
          </Tooltip>
        )}
      </div>
      {action && <div className={styles.action}>{action}</div>}
    </div>

    <Spin spinning={loading} className={styles.spin}>
      <div className={`${styles.body} ${flush ? styles.bodyFlush : ""}`}>
        {isEmpty ? (
          <div className={styles.empty}>
            <EmptyState compact icon={icon} title={emptyTitle} description={emptyText} />
          </div>
        ) : (
          children
        )}
      </div>
    </Spin>
  </div>
);

export default ChartCard;
